
import {Doughnut} from "react-chartjs-2";
import {
  convertToTableTreeData,
  DataType,
  getPieChartData,
  makePieChartOptions
} from "./helper";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { activityStore } from "../../../../../store/activity.store";
import { themeStore } from "../../../../../store/theme.store";
import style from './style.module.css';
import React, { useState } from "react";
import {formattedDuration} from "../../../../../utils/dateTime";
import {useLocalStorage} from "react-use";
import {Settings} from "../../../../../model/auth.model";
import {APP_SETTINGS_LS_KEY} from "../../../../../constant/key";
import { ChevronRight } from "lucide-react";
import { cn } from "../../../../../lib/utils";

ChartJS.register(ArcElement, Tooltip, Legend);

interface StatisticsRowProps {
  item: DataType;
  level?: number;
}

const StatisticsRow: React.FC<StatisticsRowProps> = ({ item, level = 0 }) => {
  const [expanded, setExpanded] = useState(false);
  const hasChildren = item.children && item.children.length > 0;

  return (
    <div>
      <div
        className={cn(
          "flex justify-between items-center py-2 px-2 hover:bg-muted/50 rounded cursor-pointer",
          level > 0 && "ml-4"
        )}
        onClick={() => hasChildren && setExpanded(!expanded)}
      >
        <div className="flex items-center gap-2">
          {hasChildren && (
            <ChevronRight
              className={cn(
                "h-4 w-4 transition-transform",
                expanded && "rotate-90"
              )}
            />
          )}
          {!hasChildren && <div className="w-4" />}
          <div
            style={{ background: item.color }}
            className={style.ActivityTypesFilterLabelColor}
          />
          <span className={style.TypeLabel}>{item.name}</span>
        </div>
        <div className="duration font-medium">{item.duration}</div>
      </div>
      {expanded && item.children && (
        <div>
          {item.children.map((child) => (
            <StatisticsRow key={child.key?.toString()} item={child} level={level + 1} />
          ))}
        </div>
      )}
    </div>
  );
};

const ActivityPie = () => {
  const statistics = activityStore(state => state.statistics);
  const isDark = themeStore(state => state.isDark);

  const [settings] = useLocalStorage<Settings | null>(
    APP_SETTINGS_LS_KEY,
    null
    // ,{ raw: true }
  );

  const grouped = settings?.displayGroupsInBarStatistics ?? false
  const animated = true;

  return (
    statistics && (
      <div className="flex flex-wrap">
        <div className="w-full lg:w-1/2">
          <div className={style.ActivityPie}>
            <Doughnut
              style={{ maxHeight: 300, maxWidth: 300 }}
              data={getPieChartData(
                grouped ? statistics.total.groupedStatistics : statistics.total.statistics,
                statistics.types,
                isDark)}
              options={makePieChartOptions(
                grouped ? statistics.total.groupedStatistics : statistics.total.statistics,
                animated
              )}
            />
          </div>
        </div>
        <div className="w-full lg:w-1/2">

          <div className={`flex justify-between ${style.DaysIntervalContent}`}>
            <div className={style.InfoRow}>
              <h3>Total</h3>
            </div>
            <div className={style.InfoRow}>
              <h3>{formattedDuration(statistics.total.info.total * 1000)}</h3>
            </div>
          </div>

          <div className="mt-2">
            {convertToTableTreeData(
              grouped ? statistics.total.groupedStatistics : statistics.total.statistics,
              statistics.types
            ).map((item) => (
              <StatisticsRow key={item.key?.toString()} item={item} />
            ))}
          </div>

        </div>

      </div>

    )
  );
}

export default ActivityPie;
